import type {BasePanel} from '@Components/panel/panel.types';
import type {ElementData} from '@Libraries/add-media-library';
import type {AiPanelKey} from '@Panels/stock-panel/components/stock-ai-button/stock-ai-button.types';
import {AiCarouselContentType} from '@Panels/stock-panel/stock-panel.types';

export const AI_PANEL_VOICE_FETCH_LIMIT = 20;
export const AI_PANEL_ADD_LOADING_KEY = 'addStockPanelAiItem';
export const AI_PANEL_SKELETON_COUNT = 10;
export const AI_PANEL_SKELETON_WIDTH = 120;
export const STOCK_AI_PANEL_ID = 'STOCK_AI_PANEL';
export const STOCK_AI_PANEL_SELECTION_GROUP_ID = 'stock-ai-panel-selection-group';
export const STOCK_AI_PANEL_ADD_BUTTON_ID_PREFIX = 'stock-ai-panel-add-button-';
export const AI_PANEL_DEFAULT_CONTENT_TYPES = [AiCarouselContentType.IMAGES, AiCarouselContentType.VIDEOS, AiCarouselContentType.AUDIO];

export interface StockAiPanelRow {
  type: AiCarouselContentType;
  icon: string;
  titleKey: string;
  createTextKey: string;
  createImage: string;
  toolKey: AiPanelKey;
  carouselId: string;
}

export const STOCK_AI_PANEL_ROWS: StockAiPanelRow[] = [
  {
    type: AiCarouselContentType.IMAGES,
    icon: 'icon-ai-image',
    titleKey: 'pmwjs_ai_images',
    createTextKey: 'pmwjs_create_images',
    createImage: 'stock-ai-panel-create-images.webp',
    toolKey: 'ai-images',
    carouselId: 'stock-ai-panel-images-carousel',
  },
  {
    type: AiCarouselContentType.VIDEOS,
    icon: 'icon-video-ai',
    titleKey: 'pmwjs_ai_videos',
    createTextKey: 'pmwjs_create_videos',
    createImage: 'stock-ai-panel-create-videos.webp',
    toolKey: 'ai-videos',
    carouselId: 'stock-ai-panel-videos-carousel',
  },
  {
    type: AiCarouselContentType.AUDIO,
    icon: 'icon-ai-voice',
    titleKey: 'pmwjs_ai_voice',
    createTextKey: 'pmwjs_create_voiceovers',
    createImage: 'stock-ai-panel-create-voiceovers.webp',
    toolKey: 'ai-voice',
    carouselId: 'stock-ai-panel-voice-carousel',
  },
];

export interface StockAiPanelProps extends BasePanel {
  aiCarouselContentTypes?: AiCarouselContentType[];
  shouldLoadDataUrlImage?: boolean;
  enableDragToCanvas?: boolean;
  // When set, items are multi-selected (badge + footer) instead of added on a single click — mirrors the main stock panel's selection flow.
  enableSelection?: boolean;
  maxSelectionNumber?: number;
  selectionCtaText?: string;
  // When set, all picked items go to onAddSelected in one call (e.g. one slideshow from N slides); the default streams each item as its upload settles — mirrors the main stock panel's addInBulk.
  addInBulk?: boolean;
  onAddSelected: (items: ElementData[]) => void | Promise<void>;
  onOpenAiTool: (key: AiPanelKey) => void;
  onBack: () => void;
  onClose: () => void;
}
